import { readFormField } from '../ad_campaign/dom-helpers';
import { materialIdAttr } from './materials';
import { startAdSetCreateProgress } from './progress';

export function readGeoLocations(): string[] {
  return $('#ad-set-modal-body [data-role="adset-geo-location"] input[type="checkbox"]:checked')
    .map((_i, el) => (el as HTMLInputElement).value)
    .get();
}

export function submitCreateAdSet($btn: JQuery): void {
  const $body = $('#ad-set-modal-body');
  const audienceId = $body.attr('data-audience-id');
  const squareId = $body.attr(materialIdAttr('square'));
  const storyId = $body.attr(materialIdAttr('story'));

  if (!audienceId) {
    window.alert('Select or create an audience.');
    return;
  }

  if (!squareId && !storyId) {
    window.alert('Select at least one material (square or story).');
    return;
  }

  const payload = {
    audience_id: audienceId,
    campaign_id: readFormField($body, 'campaign_id'),
    name: readFormField($body, 'name'),
    start_time: readFormField($body, 'start_time'),
    end_time: readFormField($body, 'end_time'),
    geo_locations: readGeoLocations(),
    square_material_id: squareId ?? null,
    story_material_id: storyId ?? null,
    link_to_page: readFormField($body, 'link_to_page'),
    primary_text: readFormField($body, 'primary_text'),
    headline: readFormField($body, 'headline'),
    description: readFormField($body, 'description'),
  };

  const originalHtml = $btn.html();
  const $editButtons = $('#adset-page-summary [data-edit-step]');
  $btn.prop('disabled', true).html(
    '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> &nbsp; Creating...'
  );
  $('#adset-back-btn').prop('disabled', true);
  $editButtons.prop('disabled', true);

  const restoreButtons = (): void => {
    $btn.prop('disabled', false).html(originalHtml);
    $('#adset-back-btn').prop('disabled', false);
    $editButtons.prop('disabled', false);
  };

  $.ajax({
    url: '/meta_apis/ad_sets/wizard_create',
    method: 'POST',
    contentType: 'application/json',
    headers: { 'X-CSRF-Token': document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? '' },
    data: JSON.stringify(payload),
    success: function(response: { success: boolean; ad_set_id?: string; error?: string; status?: string }) {
      if (!response.success || !response.ad_set_id) {
        window.alert(response.error ?? 'Failed to create ad set.');
        restoreButtons();
        return;
      }

      const adSetId = response.ad_set_id;
      $btn.html('<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> &nbsp; Processing on Meta...');

      window.setTimeout(() => {
        restoreButtons();
        $('#adSetModal').modal('hide');
        startAdSetCreateProgress(adSetId);
      }, 3000);
    },
    error: function(xhr) {
      const err = xhr.responseJSON?.error ?? 'Failed to create ad set.';
      window.alert(err);
      restoreButtons();
    },
  });
}
